module.exports = __webpack_public_path__ + "static/media/p-list-course.27a0afba.png";